'use client';

import { cn } from '@/lib/utils';
import patches from '@/util/intlPatches';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';

/**
 * @param {{
 *  value?:number | string
 *  currencyCode?:string
 *  specialPrice?:number
 *  classes?:{specialPrice?:string}
 *  showFractionDigits?:boolean
 * }} props
 */
const Price = props => {
  const { locale } = useIntl();
  const { value, currencyCode, specialPrice, classes = {}, showFractionDigits = true } = props;

  const isValueValid =
    ((typeof value === 'number' && !isNaN(value)) ||
      (typeof value === 'string' && !!value.trim() && !isNaN(Number(value)))) &&
    !!currencyCode;
  const isSpecialPriceValid =
    ((typeof specialPrice === 'number' && !isNaN(specialPrice)) ||
      (typeof specialPrice === 'string' && !!specialPrice.trim() && !isNaN(Number(specialPrice)))) &&
    !!currencyCode;

  const children = isValueValid
    ? patches.toParts
        .call(
          new Intl.NumberFormat(
            locale,
            Object.assign(
              {
                style: 'currency',
                currency: currencyCode,
              },
              showFractionDigits ? {} : { minimumFractionDigits: 0, maximumFractionDigits: 0 },
            ),
          ),
          value,
        )
        .map((part, i) => {
          const key = `${i}-${part.value}`;

          return <span key={key}>{part.value}</span>;
        })
    : null;

  const specialPriceChildren = isSpecialPriceValid
    ? patches.toParts
        .call(
          new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
          }),
          specialPrice,
        )
        .map((part, i) => {
          const key = `${i}-${part.value}`;

          return <span key={key}>{part.value}</span>;
        })
    : null;

  return (
    <Fragment>
      {children}
      {value < specialPrice && specialPriceChildren ? (
        <span className={cn('ml-[7px] text-sm leading-5 text-aba6a0 line-through', classes.specialPrice)}>
          {specialPriceChildren}
        </span>
      ) : null}
    </Fragment>
  );
};

export default Price;
